<template>
	<div class="safety">
		<div class="safetyTitle">
			Safety
		</div>
		<div class="groupFieldWrapper">
			<div class="groupField_wrap">
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Customer rate"
						placeholder="0"
						:setInputValue="customer_rate"
						is-readonly
				></field>
				<field
            :class-error="valid.services.safety.driver_rate.$error"
            margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Driver rate"
						placeholder="0"
						:setInputValue="driver_rate"
						@updateInput="onInput($event, 'driver_rate')"
            is-required
				></field>

				<div class="informationWrapper">
					<safety-information
							v-if="driver_id"
							:information="information"
							:endpoint="`/safety/driver/${driver_id}`"
							@update="onInformationUpdate"
							@saved="onInformationSaved"
					/>
				</div>
			</div>

<!--			<div class="groupFieldWrapper">
				<div class="groupFieldWrapper_title">ELD</div>
				<div class="groupField_wrap">
					<field
							:class-error="valid.eld_name.$error"
							margin="10px 10px 0 0"
							width="210px"
							label="ELD name"
							placeholder="Enter name"
							@updateInput="onInput($event, 'eld_name')"
							:setInputValue="eld_name"
							is-required
					></field>
					<field
							:class-error="valid.eld_url.$error"
							margin="10px 10px 0 0"
							width="215px"
							label="URL"
							placeholder="Enter URL"
							@updateInput="onInput($event, 'eld_url')"
							:setInputValue="eld_url"
							is-required
							is-clip
							is-link
					></field>
					<field
							:class-error="valid.eld_login.$error"
							margin="10px 10px 0 0"
							width="215px"
							label="Login"
							placeholder="Enter login"
							@updateInput="onInput($event, 'eld_login')"
							:setInputValue="eld_login"
							is-required
							is-clip
					></field>
					<field
							:class-error="valid.eld_password.$error"
							margin="10px 10px 0 0"
							width="210px"
							type="password"
							label="Password"
							placeholder="Enter Password"
							@updateInput="onInput($event, 'eld_password')"
							:setInputValue="eld_password"
							is-required
							is-clip
							is-pass
					></field>
				</div>
			</div>-->
		</div>
	</div>
</template>

<script>
import SafetyInformation from "@/components/SafetyInformation/SafetyInformation.vue";

export default {
	name: "Safety",
	components: { SafetyInformation },
	props: {
		valid: Object,
		eld_name: String,
		eld_url: String,
		eld_login: String,
		eld_password: String,
		customer_rate: Number,
		driver_rate: [ Number, String ],
		driver_id: Number,
		information: {
			type: String,
			default: ""
		}
	},
	methods: {
		onInput({ value }, key) {
			this.$emit('updateSafetyRate', value, key);
		},

		onInformationUpdate(value) {
			this.$emit("updateSafetyRate", value, "information");
		},

		onInformationSaved(data) {
			this.$emit("safetyInformationSaved", data);
		}
	}
};
</script>

<style scoped lang="scss">
@import "Safety";
</style>
